module.exports = __webpack_public_path__ + "img/news3.025be6df.png";